const translations = {
    delete: 'Delete...',
    rename: 'Rename'
};

export default translations;
